import React, { useId } from 'react';

const GitaLogo = ({
  size = 40,
  className = '',
  title = 'Bhagavad Gita',
}) => {
  const uid = useId().replace(/:/g, '');
  const bgId = `gita-logo-bg-${uid}`;
  const goldId = `gita-logo-gold-${uid}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      <defs>
        <linearGradient id={bgId} x1="6" y1="4" x2="42" y2="44" gradientUnits="userSpaceOnUse">
          <stop stopColor="#6b0f2a" />
          <stop offset="1" stopColor="#4a0818" />
        </linearGradient>
        <linearGradient id={goldId} x1="8" y1="8" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop stopColor="#e8c547" />
          <stop offset="0.45" stopColor="#d97706" />
          <stop offset="1" stopColor="#c9a227" />
        </linearGradient>
      </defs>

      <circle cx="24" cy="24" r="23" fill={`url(#${bgId})`} />
      <circle cx="24" cy="24" r="22" stroke={`url(#${goldId})`} strokeWidth="1.4" opacity="0.85" />

      <text
        x="24"
        y="32"
        textAnchor="middle"
        fontSize="26"
        fill="#d97706"
        fontFamily="serif"
      >
        ॐ
      </text>
    </svg>
  );
};

export default GitaLogo;
